type GameAndPeriodValue = {
  period: string | null;
  game: string | null;
};

type TieBreakPeriod = {
  period: string | null;
  tieBreakPeriod: string | null;
};

export function getTennisPeriodsValue(value: string | GameAndPeriodValue | TieBreakPeriod) {
  if (isGamePeriod(value)) {
    return `${value.period}, ${value.game}`;
  }

  if (isTieBreakPeriod(value)) {
    return `${value.period}, ${value.tieBreakPeriod}`;
  }

  return value;
}

function isTieBreakPeriod(value: unknown): value is TieBreakPeriod {
  return value instanceof Object && 'period' in value && 'tieBreakPeriod' in value;
}

function isGamePeriod(value: unknown): value is GameAndPeriodValue {
  return value instanceof Object && 'period' in value && 'game' in value;
}

